import React from "react";
import { Card, Typography, Box, Button } from "@mui/material";

const CardItem = ({ title, labName, mentorName, isActive, onClick }) => {
  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: 3,
        width: "100%",
        maxWidth:320,
        transition: "transform 0.3s ease, opacity 0.3s ease",
        opacity: isActive ? 1 : 0.5,
        pointerEvents: isActive ? "auto" : "none",
        cursor: isActive ? "pointer" : "not-allowed",
        "&:hover": {
          transform: isActive ? "scale(1.05)" : "none",
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" mb={2} alignItems="center">
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          sx={{
            fontSize: { xs: "14px", sm: "16px", md: "18px", lg: "20px" },
          }}
        >
          {title}
        </Typography>
        <Button
          variant="contained"
          size="small"
          color={isActive ? "success" : "secondary"}
          onClick={onClick}
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            cursor: isActive ? "pointer" : "not-allowed",
          }}
        >
          {isActive ? "Active" : "Inactive"}
        </Button>
      </Box>
      <Typography variant="body2" mb={1}    sx={{
            fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" },
          }}>
        <strong>Lab: </strong> {labName}
      </Typography>
      <Typography variant="body2" sx={{
            fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" },
          }}>
        <strong>Mentor: </strong> {mentorName}
      </Typography>
    </Card>
  );
};

export default CardItem;
